import React, { useCallback } from 'react';
import { FormControlLabel, Switch } from '@material-ui/core';
import { SwitchProps } from '@material-ui/core/Switch';
import { useFormContext } from 'react-hook-form';
import { useId } from '../../hooks';
import { ClassApi } from '../../types/styles';
import useStyles from './styles';

type Props = Omit<SwitchProps, 'classes'> & {
  name: string;
  label: React.ReactNode;
  topLabel?: string;
  classes?: ClassApi<typeof useStyles>;
  onChangeCallback?: (checked: boolean) => void;
};

const ReactFormSwitch = ({
  name,
  label,
  topLabel,
  disabled,
  classes: classesExternal,
  onChangeCallback,
  ...props
}: Props) => {
  const classes = useStyles({ classes: classesExternal });
  const { setValue, watch } = useFormContext();
  const value = watch(name);
  const checkboxId = useId('checkbox-');

  const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    setValue(name, checked);
    if (onChangeCallback) {
      onChangeCallback(checked);
    }
  }, [onChangeCallback, name, setValue]);

  return (
    <div>
      {topLabel && <div className={classes.topLabel}>{topLabel}</div>}
      <FormControlLabel
        disabled={disabled}
        label={label}
        htmlFor={checkboxId}
        classes={{
          root: classes.root,
          label: classes.label,
        }}
        control={(
          <Switch
            id={checkboxId}
            name={name}
            disabled={disabled}
            {...props}
            onChange={handleChange}
            checked={value}
            value={value}
            classes={{
              switchBase: classes.switchBase,
              checked: classes.checked,
              track: classes.track,
            }}
          />
        )}
      />
    </div>
  );
};

export default ReactFormSwitch;
